module.exports = __webpack_public_path__ + "static/media/24-2.d693b7e4.mp3";